import { useState } from "react";

import SearchBox from "../../components/SearchBox/SearchBox";
import Gallery from "../../components/Gallery/Gallery";

import { searchObjects, getObject } from "../../services/metService";

export default function HomePage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  async function handleSearch(query) {
    setSearchQuery(query);
    setLoading(true);
    setItems([]);

    // 1. Buscar IDs pelo termo
    const result = await searchObjects(query);

    if (!result || !result.objectIDs || result.objectIDs.length === 0) {
      setLoading(false);
      return;
    }

    // 2. Limitar quantidade (performance)
    const limitedIDs = result.objectIDs.slice(0, 20);

    // 3. Buscar detalhes
    const details = await Promise.all(
      limitedIDs.map((id) => getObject(id))
    );

    const validItems = details.filter(Boolean);

    setItems(validItems);
    setLoading(false);
  }

  return (
    <div style={{ padding: "30px" }}>
      <SearchBox onSearch={handleSearch} />

      {loading && <p>Carregando resultados...</p>}

      {!loading && items.length > 0 && <Gallery items={items} />}

      {!loading && searchQuery && items.length === 0 && (
        <p>Nenhum resultado encontrado para "{searchQuery}".</p>
      )}
    </div>
  );
}
